<template>
  <div class="drag-recommend">
   <v-toolbar color="elevation-0" light>
      <v-toolbar-title><v-subheader>Priority</v-subheader></v-toolbar-title>
      <v-toolbar-title><v-subheader>Recommendations</v-subheader></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title><v-subheader>Delete</v-subheader></v-toolbar-title>
    </v-toolbar>

    <v-sheet depressed v-if="draggableItems.length === 0" class="ml-5 body-1 grey--text text--darken-2">No Data Found</v-sheet>
    <v-list v-else subheader height="400" class="overflow-x-auto">
      <draggable v-model="draggableItems" handle=".handle">
        <v-list-item
          v-for="(item, index) in draggableItems"
          :key="index"
        >
          <v-list-item-avatar>
            <i class="fas fa-grip-lines text--disabled handle"></i>
            {{index+1}}
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-text="item.name"></v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="deleteItem(item)">
              <v-icon color="grey lighten-1">mdi-close</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </draggable>
    </v-list>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { CategoryAPI } from '@/clients/product/category.api'

export default {
  props: ['activeSkus'],
  data() {
    return {
      items: this.activeSkus
    }
  },
  components: {
    draggable
  },
  computed: {
    draggableItems: {
      get: function() {
        return this.items
      },
      set: function(filteredItems) {
        this.items = filteredItems
        if(this.items.length > 0) {
          this.postRecommendations()
        }
      }
    }
  },
  watch: {
    activeSkus() {
      this.items = this.activeSkus
    }
  },
  methods: {
    async deleteItem(item) {
      try {
        this.spinner(true)
        await CategoryAPI.deleteRecommendations(item.LocationCategoryRecommendation.id);
        let filtered = []
        Object.keys(this.draggableItems).map(key => {
          if (this.draggableItems[key].id !== item.id) {
            filtered.push(this.draggableItems[key])
          }
        })
        this.draggableItems = filtered;
        this.spinner(false)
      } catch (err) {
        this.spinner(false)
        this.snackbar({
          text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
          open: true,
          color: 'error'
        })
      }
    },
    async postRecommendations() {
      var skuIds = this.items.map(item => item.LocationCategoryRecommendation.id);
      if (!skuIds.length) return
      try {
        this.spinner(true)
        await CategoryAPI.postRecommendations(skuIds);
        this.spinner(false)
      } catch (err) {
        this.spinner(false)
        this.snackbar({
          text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
          open: true,
          color: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.drag-recommend {
  .v-list-item {
    border-bottom: 1px solid rgba(0,0,0,0.2);
  }

  .v-avatar.v-list-item__avatar {
    user-select: none;
    width: 60px !important;
  }

  .handle {
    cursor: pointer;
    margin-right: 8px;
  }
}
</style>
